import React, { useState } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Box,
  Button,
} from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import SoundsTable from "src/components/Sounds/SoundsTable";

const SfxTable = ({ searchTerm }) => {
  const [sortConfig, setSortConfig] = useState({ key: null, direction: null });

  const handleSort = (key, direction) => {
    setSortConfig({ key, direction });
  };

  return (
    <TableContainer>
      <Table sx={{ borderCollapse: "separate", borderSpacing: "0 8px" }}>
        <TableHead>
          <TableRow>
            <TableCell
              sx={{
                color: "#464A53",
                borderBottom: "none",
              }}
            >
              <Box display="flex" alignItems="center">
                Action ID
                <Box ml={0.5} display="flex" flexDirection="column">
                  <Button
                    size="small"
                    sx={{ minWidth: 0, padding: 0 }}
                    onClick={() => handleSort("id", "asc")}
                  >
                    <KeyboardArrowUpIcon fontSize="small" />
                  </Button>
                  <Button
                    size="small"
                    sx={{ minWidth: 0, padding: 0 }}
                    onClick={() => handleSort("id", "desc")}
                  >
                    <KeyboardArrowDownIcon fontSize="small" />
                  </Button>
                </Box>
              </Box>
            </TableCell>

            <TableCell
              sx={{
                color: "#464A53",
                borderBottom: "none",
                paddingLeft: "5px",
              }}
            >
              Preview
            </TableCell>

            <TableCell
              sx={{
                color: "#464A53",
                borderBottom: "none",
              }}
            >
              <Box display="flex" alignItems="center">
                File
                <Box ml={0.5} display="flex" flexDirection="column">
                  <Button
                    size="small"
                    sx={{ minWidth: 0, padding: 0 }}
                    onClick={() => handleSort("file", "asc")}
                  >
                    <KeyboardArrowUpIcon fontSize="small" />
                  </Button>
                  <Button
                    size="small"
                    sx={{ minWidth: 0, padding: 0 }}
                    onClick={() => handleSort("file", "desc")}
                  >
                    <KeyboardArrowDownIcon fontSize="small" />
                  </Button>
                </Box>
              </Box>
            </TableCell>

            <TableCell
              sx={{
                color: "#464A53",
                borderBottom: "none",
                paddingLeft: "5px",
              }}
            >
              Upload New File
            </TableCell>

            <TableCell
              sx={{
                color: "#464A53",
                borderBottom: "none",
              }}
            >
              <Box display="flex" alignItems="center">
                On/Off
                <Box ml={0.5} display="flex" flexDirection="column">
                  <Button
                    size="small"
                    sx={{ minWidth: 0, padding: 0 }}
                    onClick={() => handleSort("enabled", "asc")}
                  >
                    <KeyboardArrowUpIcon fontSize="small" />
                  </Button>
                  <Button
                    size="small"
                    sx={{ minWidth: 0, padding: 0 }}
                    onClick={() => handleSort("enabled", "desc")}
                  >
                    <KeyboardArrowDownIcon fontSize="small" />
                  </Button>
                </Box>
              </Box>
            </TableCell>
          </TableRow>
        </TableHead>

        <SoundsTable searchTerm={searchTerm} sortConfig={sortConfig} />
      </Table>
    </TableContainer>
  );
};

export default SfxTable;
